import Select from './Select';

export default Select;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/common/select/index.js